export { default as Dashboard } from './Dashboard'
export { default as Shifts } from './Shifts'
export { default as Users } from './Users'
export { default as Paper } from './Paper'
export { default as Logout } from './Logout'
export { default as PieChart } from './PieChart'
export { default as Settings } from './Settings'
export { default as Stock } from './Stock'
export { default as Folder } from './Folder'
export { default as Operations } from './Operations'
export { default as Inventory } from './Inventory'
export { default as Globe } from './Globe'
export { default as SortList } from './SortList'
export { default as SortCalendar } from './SortCalendar'
export { default as Exchange } from './Exchange'
export { default as Plus } from './Plus'
export { default as Minus } from './Minus'
export { default as ArrowLeft } from './ArrowLeft'
export { default as ArrowRight } from './ArrowRight'
export { default as PlusCircle } from './PlusCircle'
export { default as Checkmark } from './Checkmark'
export { default as Decline } from './Decline'
export { default as Download } from './Download'
export { default as Pencil } from './Pencil'
export { default as Plates } from './Plates'
export { default as Chef } from './Chef'
export { default as Trash } from './Trash'
export { default as Play } from './Play'
export { default as Stop } from './Stop'
export { default as CheckmarkCircle } from './CheckmarkCircle'
export { default as ExclamationCircle } from './ExclamationCircle'
export { default as Eye } from './Eye'
export { default as Refresh } from './Refresh'
export { default as Bell } from './Bell'
export { default as User } from './User'
export { default as Up } from './Up'
export { default as Down } from './Down'
export { default as Right } from './Right'
export { default as Left } from './Left'
export { default as PlusSquare } from './PlusSquare'
export { default as Heart } from './Heart'
export { default as Home } from './Home'
export { default as Shirt } from './Shirt'
export { default as Timer } from './Timer'
export { default as Salary } from './Salary'
export * as Smileys from './smileys'
